module.exports = __webpack_public_path__ + "media/src/img/logo-main-c802f23940a1e1492a6a1989bc95ebf3.png";